import IconsPickupInStore from '~icons/icons/PickupInStore.svg'

export const iconMapping = {
  store: IconsPickupInStore,
}
